import classNames from 'classnames';
import moment from 'moment';
import React, { ChangeEvent, KeyboardEvent, useState } from 'react';
import { PrimaryButton } from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { useNotesCRUDActions } from '@mm/state/actions/NotesCRUDActions';
import NoteModel from '@mm/state/model/NoteModel';
import { AccordionItem } from '@mm/components';
import './Notes.pcss';
import { FileTextFilled } from '@ant-design/icons';
import TextInput from '../../../../../../common/components/TextInput';
import { SelectedContact } from '@mm/state/interfaces/contacts';
import { Spin } from 'antd';

type Props = {
  notes: NoteModel[];
  contactId: number;
  selectedContact?: SelectedContact;
  onChange: (busyComponent: string) => void;
  collapsedContactView?: boolean;
  busy?: string[];
};

export const Notes = (props: Props) => {
  const {
    notes,
    onChange,
    collapsedContactView,
    selectedContact,
    contactId,
    busy,
  } = props;
  const [showAddForm, setAddShowForm] = useState(false);
  const [newNoteText, setNewNoteText] = useState('');
  const className = classNames('live-chat--contact-notes');
  const isDummayContact = selectedContact?.dummy;

  const notesBusyName = 'notes';

  const { addNote: addNoteAction } = useNotesCRUDActions();

  const onNoteAdd = (noteText: string) => {
    if (contactId) {
      return addNoteAction(noteText, contactId);
    }
  };

  const addNote = async () => {
    if (isDummayContact) return;
    const noteText = newNoteText.trim();
    if (noteText) {
      await onNoteAdd(noteText);
      onChange(notesBusyName);
      setAddShowForm(false);
      setNewNoteText('');
    }
  };
  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (!e.shiftKey && e.which === 13) {
      e.preventDefault();
      addNote();
    }
  };

  const handleSetNewNoteText = (e: ChangeEvent<HTMLTextAreaElement>) =>
    setNewNoteText(e.target.value);

  if (collapsedContactView) {
    return (
      <div className="live-chat--contact__header--collapsed">
        <FileTextFilled className="contact-details__header-icon" />
        <span className="live-chat--contact__content-number--collapsed">
          ({notes.length})
        </span>
      </div>
    );
  }
  return (
    <div className={className}>
      <AccordionItem
        icon={
          <FileTextFilled className="contact-details__nested-header-icon" />
        }
        title="Notes"
        count={notes.length}
        className="contact-details__nested-accordion-item"
        headingClassName="contact-details__accordion-item-heading"
        childrenWrapperClassName="contact-details__accordion-item-children-container"
        withBorder={false}
        closeOnOutsideClick={false}
      >
        <>
          <div className="live-chat--contact-section-title-container">
            <TextInput
              value={newNoteText}
              onKeyPress={handleKeyPress}
              onChange={handleSetNewNoteText}
              className="contact-details__note-input"
            />

            <PrimaryButton
              className="live-chat--contact-notes-add-btn"
              disabled={newNoteText.trim().length === 0 || isDummayContact}
              onClick={addNote}
            >
              Add
            </PrimaryButton>
          </div>
          <Spin size="small" spinning={busy?.includes(notesBusyName)} />
          {notes.map((note: NoteModel) => (
            <div key={note.id}>
              <div className="live-chat--contact__note">{note.body}</div>
              <div className="live-chat--contact__note-time">
                {moment(note.createdAt).format('MMMM D')}
              </div>
            </div>
          ))}
        </>
      </AccordionItem>
    </div>
  );
};
